import { gql } from '@apollo/client';

export interface TikTokExceptionReportOrderItem {
    id: string;
    warehouseId: string;
    trackingNumber: string;
    exceptionReasonCode: string;
    exceptionSubReasonCode: string | null;
    status: number;
    action: string | null;
    externalExceptionId: string | null;
    awbUrl: string | null;
    createdAt: number;
    callbackAt: number | null;
}

export interface TikTokExceptionReportOrderListing {
    content: TikTokExceptionReportOrderItem[];
    page: number;
    size: number;
    totalElements: number;
    totalPages: number;
}

export interface GetTikTokExceptionReportOrdersResponse {
    getTikTokExceptionReportOrders: TikTokExceptionReportOrderListing;
}

export interface TikTokExceptionReportOrderFiltersInput {
    createdAtFrom: number;
    createdAtTo: number;
    trackingNumbers?: string[];
    exceptionReasonCode?: string;
}

export interface GetTikTokExceptionReportOrdersVariables {
    warehouseId: number;
    filters: TikTokExceptionReportOrderFiltersInput;
    pageRequest: {
        page: number;
        size: number;
    };
}

export const GET_TIKTOK_EXCEPTION_REPORT_ORDERS = gql`
    query GetTikTokExceptionReportOrders(
        $warehouseId: Long!
        $filters: TikTokExceptionReportOrderFiltersTypeInput!
        $pageRequest: PageRequestTypeInput!
    ) {
        getTikTokExceptionReportOrders(
            warehouseId: $warehouseId
            filters: $filters
            pageRequest: $pageRequest
        ) {
            content {
                id
                warehouseId
                trackingNumber
                exceptionReasonCode
                exceptionSubReasonCode
                status
                action
                externalExceptionId
                awbUrl
                createdAt
                callbackAt
            }
            page
            size
            totalElements
            totalPages
        }
    }
`;
